<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['展商联系人']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-button class="btns-add" icon="el-icon-plus" size="small" @click="add" >添加</el-button>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" style="width: 100%" class="flex-1" stripe height="100%" border>
            <el-table-column type="index" width="60px" align="center" label="序号" fixed=""> </el-table-column>
            <el-table-column label="联系人姓名" prop="name" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="品牌" prop="brandName" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="邮箱" prop="email" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="手机号码" prop="phone" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="网址" prop="website" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" width="140" label="操作" fixed="right">
              <template v-slot="scope">
                <div class="btn-box">
                  <el-button icon="el-icon-edit" type="text" @click="goDetail(scope.row.id)" size="small">编辑</el-button>
                  <el-button icon="el-icon-delete" type="text" @click="deleteItem(scope.row.id)" size="small">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes" :total="total">
          </el-pagination>
        </el-row>
      </el-card>
    </div>

    <el-dialog width="30%" :title="title" :visible.sync="dialogVisible" :close-on-click-modal="false" :show-close="false" @close="cancel">
      <el-form ref="form" class="add-form" :model="form" :rules="rules" label-width="120px" v-loading="loading">
        <el-form-item label="联系人名称：" prop="name">
          <el-input v-model="form.name" ></el-input>
        </el-form-item>
        <el-form-item label="品牌：" prop="brandId" v-if="isShowBrand">
          <el-select v-model="form.brandId" placeholder="请选择" clearable style="width: 100%" v-if="!form.id">
            <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
          <el-input v-model="form.brandName" disabled v-else></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-select v-model="form.type" @change="changeType" style="width: 100%">
            <el-option label="邮箱" value="1"></el-option>
            <el-option label="手机号码" value="2"></el-option>
            <el-option label="网址" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email" v-if="form.type === '1'">
          <el-input v-model="form.email" ></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="phone"  v-if="form.type === '2'">
          <el-input v-model="form.phone" ></el-input>
        </el-form-item>
        <el-form-item label="网址：" prop="website"  v-if="form.type === '3'">
          <el-input v-model="form.website" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    const checkPhone = (rule, value, callback) => {
      const phone =
          /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      const _isPhone = phone.test(value)
      if (!value) {
        callback(new Error('请输入手机号码'))
      } else {
        if (_isPhone) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号码'))
        }
      }
    }

    const checkEmail = (rule, value, callback) => {
      const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
      const isEmail = filter.test(value)
      if (!value) {
        callback(new Error('请输入邮箱'))
      } else {
        if (isEmail) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱'))
        }
      }
    }

    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      loading: false,
      title: '',
      type: '',
      form: {
        id: '',
        type: '',
        name: '',
        email: '',
        phone: '',
        brandId: '',
        website: '',
        brandName: ''
      },
      rules: {
        name: {
          required: true,
          message: '请输入联系人名称',
          trigger: 'blur'
        },
        brandId: {
          required: true,
          message: '请选择品牌',
          trigger: 'blur'
        },
        type: {
          required: true,
          message: '请选择联系方式',
          trigger: 'blur'
        },
        email: {
          required: true,
          validator: checkEmail,
          trigger: 'blur'
        },
        phone: {
          required: true,
          validator: checkPhone,
          trigger: 'blur'
        },
        website: {
          required: true,
          message: '请输入网址',
          trigger: 'blur'
        }
      },
      brandList: [],
      isShowBrand: false
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getPageList()
    this.getBrand()
    this.getInfo()
  },
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      const { data: res } = await this.$http.post('/businessContact/businessContact/getPageList', params)
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      }
    },
    getInfo () {
      this.$http
        .post('/company/getById', {})
        .then((res) => {
          const data = res.data.data
          this.isShowBrand = ['1', '2'].includes(data.type)
        })
    },
    getBrand () {
      this.$http.get('/businessContact/businessContact/getBrandList').then((res) => {
        this.brandList = res.data.data || []
      })
    },
    reset () {
      this.currentPage = 1
      this.pageSize = 10
      this.getPageList()
    },
    add () {
      this.title = '新增展商联系人'
      this.dialogVisible = true
      this.getBrand()
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    goDetail (id) {
      this.getBrand()
      this.title = '编辑展商联系人'
      this.dialogVisible = true
      this.loading = true
      this.$http
        .post('/businessContact/businessContact/getById', {id})
        .then((res) => {
          if (res.data.code === '200') {
            this.form = res.data.data
            if (this.form.email) this.form.type = '1'
            if (this.form.phone) this.form.type = '2'
            if (this.form.website) this.form.type = '3'
          } else {
            this.$message.error(res.data.msg)
          }
        }).finally(() => {
          this.loading = false
        })
    },
    deleteItem (id) {
      this.$confirm('确定删除该数据?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/businessContact/businessContact/delete', { id }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    cancel () {
      this.dialogVisible = false
      this.loading = false
      this.form = { id: '', name: '', phone: '', email: '', website: '', type: '' }
      this.$refs.form.resetFields()
    },
    confirm () {
      this.$refs.form.validate((val) => {
        if (val) {
          const url = this.title === '编辑展商联系人' ? 'businessContact/businessContact/update' : 'businessContact/businessContact/add'
          this.$http.post(url, this.form).then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
              this.cancel()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    changeType () {
      this.form.website = ''
      this.form.phone = ''
      this.form.email = ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/exhibitorContactPerson/index.vue